import { parse } from 'filepond';
import flatpickr from 'flatpickr';
import $ from 'jquery';

export function initFormInputs( $context = null ){
    
    if ( $context === null ){
        $context = $( "body" );
    }
    
    $(".form__field", $context ).focusin(function(e){
        $(this).closest(".iconInput").addClass("selected");
    });

    $(".form__field", $context ).on("focusout change", function(e){
      $(this).closest(".iconInput").removeClass("selected");

      if ($(this).val() === "" || (Array.isArray($(this).val()) && $(this).val().length === 0)){
        $(this).closest(".iconInput").find(".form__label").removeClass("populated");
      } else {
        $(this).closest(".iconInput").find(".form__label").addClass("populated");        
      }
    });
    
    $(".checkbox__form__label", $context ).click(function(e){
      e.stopPropagation();
    });

    $(".checkbox-container input[type=checkbox]", $context ).change(function(e){
      var container = $($(this).closest(".checkbox-container"));
      var label = $(container.find(".checkbox__form__label"));
      if ($(this).prop("checked")){
        label.addClass("populated");
      } else {
        label.removeClass("populated");

      }
    });

    $(".checkbox-container", $context ).click(function(e){
      if ($(this).parent().hasClass("switchContainer")){
        return;
      }
      e.stopPropagation();
      var label = $($(this).find(".checkbox__form__label"));
      if (label.length > 0){
        label.trigger("click");
      }
    });

    $(".form__field", $context).each(function(i){
      if ($(this).val() !== "" && ! $.isEmptyObject($(this).val())){
        $(this).closest(".iconInput").find(".form__label").addClass("populated");        
      } else {
          $(this).closest(".iconInput").find(".form__label").removeClass("populated");
      }
    });

    $(".iconInput .clear-input-btn", $context).click(function(e){
      e.preventDefault();
    })

    $(".select2", $context).on("focusin", ".select2-search__field", (function(e){
        $(this).closest(".form__group").find(".form__label").addClass("populated");
    }));

    $(".select2", $context).on("select2:close", function(e){
        if($(this).parent().find(".select2-selection__rendered").children().length <= 1){
            $(this).parent().find(".form__label").removeClass("populated");
        }
    });
}

export const dateDataFormat = "Y-m-d";
export const timeDataFormat = "H:i:S";
export const dateTimeDataFormat = dateDataFormat + " " + timeDataFormat;

export function getDefaultFlatpickrOptionsDate( userDateFormat, extraOptions = {} ){
  
  flatpickr.l10ns.default.firstDayOfWeek = 1;  
  
  var flatpickrOptions = {
    enableTime: false,
    dateFormat: dateDataFormat,
    altInput: true,
    altFormat: userDateFormat,
    altInputClass: "",
    disableMobile: true,
    allowInput: true,
    onClose(dates, currentdatestring, picker) {
        picker.setDate(picker.altInput.value, true, picker.config.altFormat)
    }
  };
  
  Object.assign(flatpickrOptions, extraOptions);
  
  return flatpickrOptions;
}

export function getDefaultFlatpickrOptionsDateTime( userDateFormat, userTimeFormat, extraOptions = {} ){
        
  flatpickr.l10ns.default.firstDayOfWeek = 1;
  
  var flatpickrOptions = {
    enableTime: true,
    dateFormat: dateTimeDataFormat,
    altInput: true,
    altFormat: userDateFormat + " " + userTimeFormat["displayFormat"],
    altInputClass: "",
    time_24hr: userTimeFormat["hr24"],
    enableSeconds: userTimeFormat["seconds"],
    disableMobile: true,
    allowInput: true,        
    onClose(dates, currentdatestring, picker){
      picker.setDate(picker.altInput.value, true, picker.config.altFormat)
    }
  };
  
  Object.assign(flatpickrOptions, extraOptions);

  return flatpickrOptions;
  
}

export function getDefaultFlatpickrOptionsTime( userTimeFormat, extraOptions = {} ){
        
  flatpickr.l10ns.default.firstDayOfWeek = 1;
  
  var flatpickrOptions = {
    noCalendar: true,
    enableTime: true,
    dateFormat: timeDataFormat,
    altInput: true,
    altFormat: userTimeFormat["displayFormat"],
    altInputClass: "",
    time_24hr: userTimeFormat["hr24"],
    disableMobile: true,
    allowInput: true,        
    onClose(dates, currentdatestring, picker){
      picker.setDate(picker.altInput.value, true, picker.config.altFormat)
    }
  };
  
  Object.assign(flatpickrOptions, extraOptions);

  return flatpickrOptions;
  
}

export function initDatePicker( $input, userDateFormat, extraOptions = {} ){
  
  var flatpickrOptions = getDefaultFlatpickrOptionsDate( userDateFormat, extraOptions );
    
  flatpickrOptions.altInputClass += " " + $input.attr("class") + " datePickerAltInput";    
  
  var flatpickr = $input.flatpickr( flatpickrOptions );      
  
  $input.closest( ".form-group, .form-group-table" ).on( "click", ".clear-input-btn", function( e ){    
      flatpickr.clear();
  });
  
  return flatpickr;
}

export function initDateTimePicker( $input, userDateFormat, userTimeFormat, extraOptions = {} ){
  
  var flatpickrOptions = getDefaultFlatpickrOptionsDateTime( userDateFormat, userTimeFormat, extraOptions );
    
  flatpickrOptions.altInputClass += " " + $input.attr("class") + " datePickerAltInput";    
  
  var flatpickr = $input.flatpickr( flatpickrOptions );  
  
  $input.closest( ".form-group, .form-group-table" ).on( "click", ".clear-input-btn", function( e ){    
    flatpickr.clear();
  }); 
}

export function initTimePicker( $input, userTimeFormat, extraOptions = {} ){
  
  var flatpickrOptions = getDefaultFlatpickrOptionsTime( userTimeFormat, extraOptions );
    
  flatpickrOptions.altInputClass += " " + $input.attr("class") + " datePickerAltInput";    
  
  var flatpickr = $input.flatpickr( flatpickrOptions );  
  
  $input.closest( ".form-group, .form-group-table" ).on( "click", ".clear-input-btn", function( e ){
    flatpickr.clear();
  });

}

export function setTimePickerValue( $input, value, timeDataFormat = timeDataFormat ){
  var flatpickr = $( $input ).get(0)._flatpickr;
  flatpickr.setDate( value, true, timeDataFormat );
  $input.trigger( 'change' );
}

export function parseDate( dateString, format ){
  return flatpickr.parseDate( dateString, format );
}

export function formatDate( dateObject, format ){
  return flatpickr.formatDate( dateObject, format );
}

export function reformatDate( dateString, inFormat, outFormat ){
  var date = parseDate( dateString, inFormat );
  return formatDate( date, outFormat ); 
}

export function setFieldMandatory( $formElement, mandatory ){
  if( mandatory ){
    $formElement.siblings("label").find(".mandatory").show();
  } else {
    $formElement.siblings("label").find(".mandatory").hide();
  }
}